export default __webpack_public_path__ + "static/media/cheese_uncooked.7e63a248.svg";